import styled from 'styled-components';

import alert from '../../assets/alert.svg';
import colors from '../../styles/colors';
import Select from '../Form/Select';

export const Container = styled.div`
  form {
    margin-bottom: 10px;
    label {
      font-weight: bold;
      margin: 20px 0 8px 0;
    }
    > span {
      display: block;
      color: #c11e1e;
      margin: 5px 0;
    }
    > span:before {
      content: url(${alert});
      padding: 0 15px 0 0;
      vertical-align: -10%;
    }

    button {
      margin: 40px 0 0 0;
      text-transform: uppercase;
      font-weight: bold;
      color: #fff;
      background-color: #eb0045;
      height: 39px;
      padding: 0 23.5px;
      border-radius: 5px;
      border-color: #eb0045;
      border: none;
      outline: none;
      transition: all 0.3s ease;

      &:hover {
        background-color: #99002e;
        border-color: #99002e;
      }

      &:active {
        background-color: #99002e;
        border-color: #99002e;
      }

      &.primary {
        color: #fff;
        background-color: #eb0045;

        &:hover {
          background-color: #99002e;
          border-color: #99002e;
        }

        &:active {
          background-color: #99002e;
          border-color: #99002e;
        }
      }

      &.secondary {
        color: #4d4d4d;
        background-color: transparent;

        &:hover {
          color: #eb0045;
          background-color: transparent;
          border-color: transparent;
        }

        &:active {
          color: #eb0045;
          background-color: transparent;
          border-color: transparent;
        }
      }

      &.block {
        width: 100%;
      }
    }
  }
  table {
    border-collapse: collapse;
    width: 100%;
    text-align: left;
    thead {
      th {
        border-bottom: 2px solid ${colors.gray};
        font-size: 12px;
        color: ${colors.gray};
        font-weight: 600;
        padding: 10px 0;
      }
    }
    tr {
      svg {
        cursor: pointer;
        transition: ease-in all 0.2s;
        fill: ${colors.gray};
        &:hover {
          fill: ${colors.primary};
        }
      }
      td {
        padding: 10px 0;
        font-size: 12px;
        color: ${colors.lightblack};
        text-align: left;
      }
      button {
        border: none;
        background: none;
      }
    }
  }
`;

export const CustomSelect = styled(Select)`
  .react-select__control {
    height: 44px;
    border: 1px solid ${colors.gray};
    transition: border 0.3s;
    padding: 0 15px;
  }
  .react-select__control--is-focused {
    border-color: ${colors.darkgray};
    box-shadow: 0 0 0 0;
    &:hover {
      border-color: ${colors.darkgray};
    }
  }

  .react-select__placeholder {
    color: ${colors.gray};
  }
  &.Select--multi {
    .Select-value {
      display: inline-flex;
      align-items: center;
    }
  }

  & .Select-placeholder {
    font-size: smaller;
  }
`;
